import { memo } from "react";

import ImageLoader from "@Components/ImageLoader";
import { defaultToTrue } from "@Components/Modules/Helpers";

import { TransitionLink } from "../common/Transition";
import type { IMomentItem } from "./MomentItem";

import * as cssPortal from "../shared/Portal.module.css";
import * as css from "./SpecialMomentsPanel.module.css";

export interface ISpecialMomentsPanel extends IMomentItem {
    bannerUrl: string;
    backgroundColor: string;
    textColor: string;
    titleMobile?: string;
    description?: string;
    onClick?: (index: number) => void;
    displayTime?: number;
}

export const SpecialMomentsPanel = memo((props: ISpecialMomentsPanel) => {
    return (
        <div className={css.specialMomentsPanelComponent}>
            <div className={css.background} style={{ backgroundColor: props.backgroundColor }}>
                <TransitionLink
                    navigateUrl={props.linkUrl}
                    className={`${cssPortal.standardContainer} ${css.backgroundImage}`}
                    hideLoading
                >
                    <ImageLoader
                        src={props.bannerUrl}
                        lazyLoading={!props.selected}
                        alt={props.title}
                        size={1200}
                    />
                    {!props.hideTitleAndButton && (
                        <div
                            className={css.mainContainer}
                            style={{ color: props.textColor, borderColor: props.textColor }}
                        >
                            <h1 className={css.title}>{props.title || props.titleMobile}</h1>
                            {props.description ? <h5>{props.description}</h5> : null}
                            {props.additionalInformation && (
                                <div className={css.additionalInformationContainer}>
                                    <h5 className={css.additionalInformation}>
                                        {props.additionalInformation}
                                    </h5>
                                </div>
                            )}
                        </div>
                    )}
                </TransitionLink>
            </div>
        </div>
    );
}, defaultToTrue);
